import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

export default function ModalVisualizarAutoTexto(props) {

  function toggle() {
    props.onModal(!props.showModal);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className="modal-autotext"
          centered
          isOpen={props.showModal}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            Visualização de autotexto
          </ModalHeader>
          <ModalBody>
          <textarea  readOnly style={{ height: '585px', width: '870px', border: 'none' , overflow: 'auto', outline: 'none', resize: 'none'}} >{props.texto}</textarea>
           </ModalBody>
          <ModalFooter>
            <Button
              onClick={!props.fechar ? toggle : props.fechar}
              className={`button-cancel`}
              color="secondary"
            >
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/app/common/tabs/autotexto/modal/visualizar/index.js